import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaTimesCircle, FaArrowLeft, FaUndo } from 'react-icons/fa';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from 'react-helmet-async';
import './PaymentFailed.css';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  
  // Read both: URL Query Param AND SessionStorage
  const typeParam = searchParams.get('type') || '';
  const sessionFlow = sessionStorage.getItem('donationFlow') || '';

  // Smart Redirection Path mapping
  const isNidhi = 
    typeParam.toLowerCase().includes('nidhi') || 
    typeParam.toLowerCase().includes('protsahan') || 
    typeParam.includes('प्रोत्साहन') ||
    sessionFlow === 'protsahan';

  const retryPath = isNidhi ? '/donate-protsahan-nidhi' : '/donate-now';

  return (
    <>
      <Helmet><title>Payment Failed | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Payment failed page for Rajput Shiksha Kosh, informing users about unsuccessful transactions and providing options to retry or return to the homepage."
        />
      </Helmet>
      
      <section className="payment-failed-page-wrapper">
        <div className="payment-failed-page-container">
          
          {/* Creative Floating Failure Visual (Matches 404 Floating Wings) */}
          <div className="payment-failed-page-visual">
            <div className="payment-failed-page-icon-box">
              <FaTimesCircle className="payment-failed-page-floating-icon" />
              <div className="payment-failed-page-shadow"></div>
            </div>
          </div>

          {/* Theme Divider (Reused matching 404 style) */}
          <div className="payment-failed-page-divider">
            <span className="payment-failed-page-divider-line"></span>
            <GiFairyWings className="payment-failed-page-divider-icon" />
            <span className="payment-failed-page-divider-line"></span>
          </div>

          {/* Text Content */}
          <div className="payment-failed-page-content">
            <h1 className="payment-failed-page-title">Payment Failed</h1>
            <p className="payment-failed-page-description">
              Your transaction was cancelled or could not be processed successfully by the bank.
            </p>
            
            {/* Trust-building bilingual info box */}
            <div className="payment-failed-page-info-box">
              <p>
                <strong>नोट / Note:</strong> यदि आपके खाते से कोई राशि कट गई है, तो वह 5-7 कार्य दिवसों के भीतर आपके मूल भुगतान खाते में स्वचालित रूप से वापस आ जाएगी। <br />
                <span className="payment-failed-page-en-note">
                  (If any amount was deducted from your account, it will be automatically refunded back to your source payment method within 5-7 working days.)
                </span>
              </p>
            </div>

            {/* Structured Actions (Retry & Home) */}
            <div className="payment-failed-page-actions">
              <Link to="/" className="payment-failed-page-btn-home">
                <FaArrowLeft className="payment-failed-page-btn-icon" />
                Back To Home
              </Link>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default PaymentFailed;